import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import AuthContext from '../SecurityConfig/AuthContext';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setLoginDetails } = useContext(AuthContext);
  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('chat_token');
    localStorage.removeItem('user_email');
    setLoginDetails({ isAuthenticated: false });
    navigate('/chatbotbase');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 2,
        zIndex: 1000,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        backgroundColor: '#1976d2',
        color: 'white',
        borderRadius: '0 0 10px 10px',
        boxShadow: 'md'
      }}
    >
      <Typography level="h3" sx={{ fontWeight: '450', display: 'flex', alignItems: 'center', gap: 1 }}>
        AI Virtual Assistant
      </Typography>

      <Box>
        {location.pathname === '/chatbotbase' && (
          <Button variant="soft" color="neutral" sx={{ mr: 1 }} onClick={() => navigate('/')}>
            Home
          </Button>
        )}
        {location.pathname === '/chatbotbase/signin' && (
          <Button variant="soft" color="neutral" sx={{ mr: 1 }} onClick={() => navigate('/')}>
            Home
          </Button>
        )}
        {location.pathname === '/chatbotbase/allfiles' && (
          <Button variant="soft" color="neutral" sx={{ mr: 1 }} onClick={() => navigate('/chatbotbase/myfiles')}>
            My Files
          </Button>
        )}
        {location.pathname === '/chatbotbase/allfiles' && (
          <Button variant="soft" color="neutral" sx={{ mr: 1 }} onClick={() => navigate('/chatbotbase/chatbot')}>
            Chatbot
          </Button>
        )}
        {location.pathname === '/chatbotbase/chatbot' && (
          <Button variant="soft" color="neutral" sx={{ mr: 1 }} onClick={() => navigate('/chatbotbase/myfiles')}>
            My Files
          </Button>
        )}
        {location.pathname === '/chatbotbase/chatbot' && (
          <Button variant="soft" color="neutral" sx={{ mr: 1 }} onClick={() => navigate('/chatbotbase/allfiles')}>
            Upload
          </Button>
        )}
        {location.pathname === '/chatbotbase/myfiles' && (
          <Button variant="soft" color="neutral" sx={{ mr: 1 }} onClick={() => navigate('/chatbotbase/allfiles')}>
            Upload
          </Button>
        )}
        {location.pathname === '/chatbotbase/myfiles' && (
          <Button variant="soft" color="neutral" sx={{ mr: 1 }} onClick={() => navigate('/chatbotbase/chatbot')}>
            Chatbot
          </Button>
        )}
        {(location.pathname === '/chatbotbase/allfiles' ||
          location.pathname === '/chatbotbase/chatbot' ||
          location.pathname === '/chatbotbase/myfiles') && (
          <Button variant="solid" color="danger" onClick={handleLogout} sx={{ marginRight: '30px' }}>
            Logout
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default Header;
